import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["rent", "sale", "marketFields"]

  connect() {
    this.toggle()
  }

  toggle() {
    if (!this.hasMarketFieldsTarget || !this.hasRentTarget) return
    this.marketFieldsTarget.classList.toggle("hidden", this.rentTarget.checked)
  }
}
